const getAudienceType = (value) => {
  const audienceTypes = [
    { label: 'Individual Investor', value: 'investor' },
    { label: 'Financial Adviser', value: 'adviser' },
  ];
  const audience = audienceTypes.find((type) => type.value === value);

  return audience ? audience.label : null;
};

const googleTagSetAudienceType = (version) => {
  window.dataLayer = window.dataLayer || [];

  const audienceType = getAudienceType(version);
  const audienceTypeExists = window.dataLayer.find((prop) => prop.audience_type !== undefined);

  if (audienceTypeExists) {
    audienceTypeExists.audience_type = audienceType;
  } else {
    window.dataLayer.push({
      audience_type: audienceType,
    });
  }
};

export default googleTagSetAudienceType;
